import { createClient, SupabaseClient } from '@supabase/supabase-js'
import { SUPABASE_CONFIG } from '../config/supabase.config'

// Safe environment variable access that works in all build environments
// Try multiple methods to access environment variables
function getEnvVar(key: string): string {
  // Method 1: Direct process.env (Create React App, Node.js)
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key] as string
  }

  // Method 2: Webpack DefinePlugin injected globals
  if (typeof window !== 'undefined' && (window as any)[key]) {
    return (window as any)[key]
  }

  // Method 3: Check if variables are defined as globals at build time
  try {
    // @ts-ignore - These might be defined by the bundler
    if (
      typeof REACT_APP_SUPABASE_URL !== 'undefined' &&
      key === 'REACT_APP_SUPABASE_URL'
    ) {
      // @ts-ignore
      return REACT_APP_SUPABASE_URL
    }
    // @ts-ignore
    if (
      typeof REACT_APP_SUPABASE_ANON_KEY !== 'undefined' &&
      key === 'REACT_APP_SUPABASE_ANON_KEY'
    ) {
      // @ts-ignore
      return REACT_APP_SUPABASE_ANON_KEY
    }
  } catch (e) {
    // Ignore errors
  }

  return ''
}

// Try environment variables first, then fall back to config file
const supabaseUrl = getEnvVar('REACT_APP_SUPABASE_URL') || SUPABASE_CONFIG.url
const supabaseAnonKey =
  getEnvVar('REACT_APP_SUPABASE_ANON_KEY') || SUPABASE_CONFIG.anonKey

// Check if Supabase is configured
export const isSupabaseConfigured = () => {
  return Boolean(supabaseUrl && supabaseAnonKey)
}

// Create Supabase client only if configured, otherwise return null
export const supabase: SupabaseClient | null = isSupabaseConfigured()
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null
